import React from 'react'
import Logoar from "./pics/logo.jpeg";
import Share from "../../components/share.js";
import "./mumbai.css";
import img from "./pics/mumbai.jpeg";
import img1 from "./pics/momni.jpeg";
import img2 from "./pics/fli_day.jpeg"
import img3 from "./pics/two.jpeg";
import img4 from "./pics/be.jpeg";
import img5 from "./pics/twooo.jpeg";
import img6 from "./pics/bea.jpeg"
import img7 from "./pics/night.jpeg";
import img8 from "./pics/foodd.jpeg";
import img9 from "./pics/last.jpeg";
import img10 from "./pics/lastt.jpeg";
import img11 from "./pics/lasttt.jpeg";
import img12 from "./pics/lastttt.jpeg";
const Mumbai = () => {
  return  (
 
    <div className="article-container">
        <img src={Logoar} alt="Logoar" className="logoarr" />
      <div className="blue-bg">
     
      
    
        <header class="entry-header">
		<h4 class="entry-meta"><a href="https://nooffensebut.vercel.app/articles" target='_blank' data-wpel-link="internal">Articles</a></h4>
		<h1 class="entry-title">Mumbai-Travel Blog</h1>
		<div class="entry-meta">
			<span class="byline">by <span class="author vcard"><a class="url fn n" href="https://nooffensebut.vercel.app/aboutus" target='_blank' data-wpel-link="internal">Harshala Rani</a></span></span><span class="meta-divider"> | </span><span class="posted-on"><a href="https://nooffensebut.vercel.app/content" target='_blank' rel="bookmark" data-wpel-link="internal"><time class="entry-date published" datetime="2018-03-01T07:27:10-05:00">29.08.2023</time><time class="updated" datetime="2018-03-01T11:10:42-05:00"></time></a><span>		</span></span></div>
	</header><br/>
       
 
  <img src={img} alt="Logoar" className="mumbai" />

        <div className="description1-4">
        <p>
Mumbai, often referred to as the "City of Dreams," the "City that never sleeps," and adorned with countless other epithets, truly lives up to each and every one of these titles. 
</p><br/>
<img src={img1} alt="Logoar" className="onei" />

<p>
My fascination for the city began when I caught a glimpse of its breathtaking aerial view from the flight. You could see the slums stretching over such a wide area, you could see the sea link-how the highway stretches in the sea. The window seat was totally paying off well. From that moment on, I knew Mumbai was totally a good idea for the perfect break. I had completed exactly one and a half years of engineering and needed a holiday getaway. So yeah, my mom and I booked flights, packed our bags, and set off. 
 </p><br/>
 <img src={img2} alt="Logoar" className="onei" />

<p>In addition to skyscrapers, this city has enchanting colonial buildings, as it is one of the former capitals of the British Government including the Gateway of India, Chhatrapati Shivaji Maharaj Terminus, and many more. These buildings enchant you with their varied architecture offering a glimpse into Mumbai's colonial past.

</p><br/>

<p>
Mumbai's colonial legacy is beautifully exemplified by the Gateway of India, an iconic monument that stands tall as a symbol of the city's historical significance. Its location at the waterfront creates a picturesque setting against the backdrop of the Arabian Sea.
</p><br/>
<img src={img3} alt="Logoar" className="twoi" />

<img src={img5} alt="Logoar" className="twoi" />



<p>The enchanting smell of the sea becomes an unforgettable part of your experience, lingering long after you've departed the city. With its advantageous coastal location, Mumbai boasts a treasure trove of approximately a dozen beaches, each drawing in a constant stream of visitors. There is no way you can set foot there in peace, on a weekend. I had the fortune of visiting 2 beaches- Chowpatty and Juhu Beach, without an unbearable amount of crowd as I was there on weekdays.
</p><br/>

<p>As evening falls, the 3.6-kilometer stretch of Marine Drive comes alive with a bustling crowd. Mumbai's essence lies in its ability to bring people from all walks of life together, transcending social and economic boundaries. Regardless of one's wealth or status, everyone is treated to the same breathtaking view along the Marine Drive, one of the mesmerizing sunsets against the backdrop of the city's towering skyscrapers.
</p><br/>
<img src={img4} alt="Logoar" className="twoi" />

<img src={img6} alt="Logoar" className="twoi" />

<p>The vibrant night culture of Mumbai left an indelible impression on me. At Colaba, the roads had unique lighting at night. One of the most awe-inspiring sights I encountered was the Chhatrapati Shivaji Maharaj Terminus, bathed in a symphony of vibrant color lighting at night. This architectural marvel, which had captivated me during the day, now took on a whole new persona under the cloak of darkness.

</p><br/>

<p>One of the remarkable aspects of Mumbai's vibrant street culture is the opportunity for late-night shopping excursions. I went shopping at the bustling lanes of Colaba Causeway at around 9 pm. The vibrant street lights illuminated the colorful array of stalls and shops, creating an inviting atmosphere that heightened my anticipation. The lively energy of the night market was contagious, and my adrenaline surged as I immersed myself in the world of bargaining and exploration. Mumbai's late-night street shopping scene in Colaba Causeway offered not just a chance to acquire unique items but also an opportunity to immerse oneself in the rhythm of the city.  
</p><br/>
<img src={img7} alt="Logoar" className="onei" />

<p>Indeed, Mumbai's authentic street food is a culinary delight that captivates the taste buds and leaves a lasting impression. The
Vada Pav, Pav Bhaji, Pani Puri, Sev Puri, Falooda, Gola, the list doesn't end at all. During my time in Mumbai, I made it a point to indulge in as many street food varieties as possible, and it was a gastronomic adventure like no other.

</p><br/>
<img src={img8} alt="Logoar" className="onei" />

<p>My time in Mumbai was one of the best times, especially with my mom as my company. This city truly stands out with its distinctive charm and unique character. From the iconic black and yellow taxis that dot the bustling streets, to the sound of waves crashing on the shores, and the aroma of delectable street food, everything creates a sensory tapestry that lingers in your memories.

</p><br/>

<p>Mumbai has a way of capturing hearts and leaving an indelible mark on all who visit. It's a city that offers a perfect break from the ordinary...</p><br/>
<img src={img12} alt="Logoar" className="threei" />
<img src={img9} alt="Logoar" className="threei" />
<img src={img10} alt="Logoar" className="threei" />
<img src={img11} alt="Logoar" className="threei" />

    <hr></hr>
</div>



          <Share/>
      </div>
</div> )}

export default Mumbai;

 


